<mat-card *ngIf="reminderTypes" class="content-card">

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <mat-card-title>
      <h5>{{caption}}</h5>
    </mat-card-title>
    <div fxFlex></div>
     <button mat-raised-button color="primary" (click)="addReminderType()">Add</button>
  </mat-card-header>

  <mat-card-content>
    <div *ngFor="let type of reminderTypes; let i = index" class="bordered-row">
      <app-email-reminder-type  
        [key]="i" 
        [reminderType]="reminderType" 
        [emailReminderType]="type" 
        [emailReminderTypes]="reminderTypes" 
        [emailTemplates]="emailTemplates"
        [invoiceType]="invoiceType">
      </app-email-reminder-type>
    </div>
  </mat-card-content>
</mat-card>